const validateHashOrigin = (hash) => {
  const digitsOnly = hash.replaceAll(/\D+/g, '');
  const isFromOldVerifica = digitsOnly.length < 16;
  return isFromOldVerifica ? hash : hash.replaceAll('-', '');
};

module.exports = validateHashOrigin;
